<div class="integration-detail-component">
  <!-- <div class="back-btn" mat-icon-button aria-label="back" (click)="backClicked()"
    style="cursor: pointer; padding: 20px 72px 0px 72px; display: flex; align-items: flex-end; width: fit-content; gap: 1rem;">
    <i class="icon-back"></i> {{ "Back" | translate }}</div> -->

  <div class="action-toolbar" style="padding: 20px">
    <div class="left-column">
      <ws-button (click)="backClicked()">
        <mat-icon>arrow_back_ios_new</mat-icon>
      </ws-button>
    </div>
  </div>
  <div class="card">
    <img
      [src]="integration.integration!.imageUrl"
      class="integration-card-logo"
    />
    <div class="integration-card-body">
      <div class="integration-card-title">
        {{ integration.integration!.name }}
        <ws-chip
          *ngIf="isStripeIntegration()"
          label="superadmin only"
          [type]="WsChipType.SECONDARY"
        ></ws-chip>
      </div>
      <div
        class="integration-card-description"
        [innerHTML]="integrationDescriptionHtml"
      ></div>
    </div>
    <div
      class="integration-card-button"
      *let="isInstalledInThisWinery() as isInstalled"
    >
      <!-- Show "Resume" button if dwspay onboarding started but not completed -->
      <ws-button
        (click)="installOrManage()"
        *ngIf="isOnboardingStartedButNotCompleted() && integration.integration!.active"
        [callToActionType]="'secondary'"
        [disabled]="!isAvailableForMyPlan"
        [wsTooltip]="getResumeSetupTooltip()"
      >
        {{ "Resume Setup" | translate }}
      </ws-button>

      <!-- Show Install button when not installed -->
      <ws-button
        *ngIf="!isOnboardingStartedButNotCompleted() && !isInstalled && integration.integration!.active && !isStripeIntegration() && !isWhatsAppIntegration()"
        (click)="installOrManage()"
        [callToActionType]="'primary'"
        [disabled]="!isAvailableForMyPlan"
        [wsTooltip]="getInstallTooltip()"
      >
        {{ "Install" | translate }}
      </ws-button>

      <!-- Show Edit button for all integrations when installed and enabled -->
      <div *ngIf="!isOnboardingStartedButNotCompleted() && isInstalled && isEnabledInThisWinery() && !isWhatsAppIntegration()" 
           style="display: flex; gap: 1rem; align-items: center;">
        <ws-button
          (click)="installOrManage()"
          [callToActionType]="'tertiary'"
        >
          {{ "Edit" | translate }}
        </ws-button>
        <!-- Show Remove button only for dwspay when connected -->
        <ws-button
          *ngIf="isConnected() && isDwspayIntegration()"
          (click)="removeDwspayIntegration()"
          [callToActionType]="'danger'"
        >
          {{ "Remove" | translate }}
        </ws-button>
      </div>
    </div>
  </div>

  <div class="content">
    <div
      *ngFor="let detail of htmlDetails"
      class="detail {{ detail.type }}"
      [innerHTML]="detail.htmlValue"
    ></div>
  </div>
</div>
